import PropTypes from 'prop-types'
import { PureComponent } from 'react'
import { connect } from 'react-redux'

import { ACCESS_LEVELS, ServerResponseSchema } from 'app'
import { ProgressBar } from 'ui'

import { permissionsFetch, permissionsSearchFetch, permissionsSetFetch, permissionsToggleFetch } from '../../actions'
import PermissionsList from '../../components/PermissionsList'
import { getStatePermissions } from '../../reducer'

import styles from './index.css'

class Permissions extends PureComponent {
  componentDidMount() {
    this.props.permissionsFetch(this.props.tournamentId)
  }

  onChange = (userId, level) =>
    this.props.permissionsSetFetch(this.props.tournamentId, userId, level, 'sports_tournaments')

  onSearchFetch = (searchKey) => this.props.permissionsSearchFetch(this.props.tournamentId, searchKey)

  onToggleState = (authId) => this.props.permissionsToggleFetch(this.props.tournamentId, authId)

  render() {
    const {
      permissions: { data, loading, search },
    } = this.props
    const accessOptions = [
      { text: 'ADMIN', value: ACCESS_LEVELS.ADMIN },
      { text: 'EDICIÓN', value: ACCESS_LEVELS.EDITOR },
      { text: 'REPORTES', value: ACCESS_LEVELS.REPORTER },
    ]

    const perms = data.map((perm) => ({
      id: perm.id,
      accessLevel: perm.level,
      deletedAt: perm.deleted_at,
      readOnly: !!perm.loading,
      user: {
        id: perm.user.id,
        avatar: perm.user.profile.avatar,
        email: perm.user.email,
        name: `${perm.user.profile.first_name} ${perm.user.profile.last_name}`,
      },
    }))

    const results = search.data.map((user) => ({
      id: user.id,
      avatar: user.profile.avatar,
      email: user.email,
      name: `${user.profile.first_name} ${user.profile.last_name}`,
      nin: user.profile.nin,
    }))

    // @todo add actions when we connect this screen with real actions
    return (
      <div className={styles.container}>
        {loading && <ProgressBar value={100} />}
        <PermissionsList
          accessOptions={accessOptions}
          isSearching={search.loading}
          onChange={this.onChange}
          onRemove={this.onToggleState}
          onRestore={this.onToggleState}
          onSearchChange={this.onSearchFetch}
          permissions={perms}
          searchResults={results}
        />
      </div>
    )
  }
}

Permissions.propTypes = {
  permissions: ServerResponseSchema.isRequired,
  permissionsFetch: PropTypes.func.isRequired,
  permissionsSearchFetch: PropTypes.func.isRequired,
  permissionsSetFetch: PropTypes.func.isRequired,
  permissionsToggleFetch: PropTypes.func.isRequired,
  tournamentId: PropTypes.string.isRequired,
}

export class Pure extends Permissions {}

Pure.displayName = 'Permissions'

export default connect((state) => ({ permissions: getStatePermissions(state) }), {
  permissionsFetch,
  permissionsSearchFetch,
  permissionsSetFetch,
  permissionsToggleFetch,
})(Permissions)
